















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { PendingOperationWrapper } from "./pendingOperationWrapper";

@Component
export default class PendingOperation extends Vue {
  @Prop()
  src: PendingOperationWrapper;
  @Prop({
    default: "Błąd operacji"
  })
  error: string;
  @Prop({
    default: 'Trwa zapisywanie...'
  })
  pending: string;
  @Prop({
    default: 'Zapisano'
  })
  success: string;
}
